import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
export function HeroSection() {
  return <section className="pt-10 sm:pt-16 pb-10 sm:pb-20 px-5 sm:px-8 lg:px-12 max-w-5xl mx-auto text-center" data-id="element-109">
      <FadeIn data-id="element-110">
        <h1 className="text-3xl sm:text-5xl lg:text-6xl text-depto-brown leading-tight mb-4 sm:mb-6" data-id="element-111">
          ¿Tenés miedo de apoyar la llave en la cerradura y encontrar un
          desastre (otra vez)?
        </h1>
        <p className="text-base sm:text-xl text-depto-brown/80 max-w-3xl mx-auto mb-6 sm:mb-10 leading-relaxed" data-id="element-112">
          El método práctico de 15 minutos para que tu perro deje de llorar,
          romper muebles y molestar a los vecinos mientras vos no estás.
        </p>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-113">
        <div className="relative max-w-xs sm:max-w-2xl mx-auto mb-8 sm:mb-12" data-id="element-114">
          <div className="absolute inset-0 bg-depto-amber/20 rounded-3xl blur-3xl transform -rotate-3" data-id="element-115"></div>
          <img src="https://cdn.magicpatterns.com/uploads/hvuyirXv5zFBxTTt89bjXG/DEPTO-DOG_Mockup_1x1.png" alt="DEPTO-DOG Kit Digital" className="relative rounded-2xl shadow-2xl w-full object-cover border-8 border-white" data-id="element-116" />
        </div>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-117">
        <Button onClick={() => document.getElementById('comprar')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-118">
          QUIERO EL MÉTODO AHORA
        </Button>
      </FadeIn>
    </section>;
}